import { useCallback } from 'react';

// Global state to track fields that should be excluded from save
const excludedFromSaveFields: Set<string> = new Set();

export const useExcludedFromSaveFields = () => {
    const addExcludedField = useCallback((fieldPath: string) => {
        excludedFromSaveFields.add(fieldPath);
    }, []);

    const removeExcludedField = useCallback((fieldPath: string) => {
        excludedFromSaveFields.delete(fieldPath);
    }, []);

    const clearAllExcludedFields = useCallback(() => {
        excludedFromSaveFields.clear();
    }, []);

    const getExcludedFields = useCallback((): Set<string> => {
        return new Set(excludedFromSaveFields);
    }, []);

    const isFieldExcluded = useCallback((fieldPath: string): boolean => {
        return excludedFromSaveFields.has(fieldPath);
    }, []);

    return {
        addExcludedField,
        removeExcludedField,
        clearAllExcludedFields,
        getExcludedFields,
        isFieldExcluded,
    };
};

// Export the global state for direct access if needed
export const getExcludedFromSaveFields = (): Set<string> => {
    return new Set(excludedFromSaveFields);
};

// Export function to clear the global state directly
export const clearExcludedFromSaveFields = (): void => {
    excludedFromSaveFields.clear();
};

